import CloseIcon from '@mui/icons-material/Close';
import { Alert, IconButton, Typography } from '@mui/material';
import { Notification } from '@core/providers/SnackbarProvider';
import useSx from './sx';

interface NotificationAlertProps {
  notification: Notification;
  onClose: (id: string) => void;
}

const NotificationAlert = ({ notification, onClose }: NotificationAlertProps) => {
  const sx = useSx(notification.type);

  return (
    <Alert
      severity={notification.type}
      variant="filled"
      sx={sx.root}
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={() => onClose(notification.id)}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      <Typography component="span" sx={sx.title}>
        {notification.title}
      </Typography>
      <Typography component="p" sx={sx.message}>
        {notification.message}
      </Typography>
    </Alert>
  );
};

export default NotificationAlert;
